import { useEffect, useState } from "react"
// import { csv2json } from "json-2-csv"
import Dataviz from "./Dataviz.js"
import WaterFooter from "./components/Footer.js"
import "./App.css"

function App() {
  const [water, setWater] = useState([])
  const [cities, setCities] = useState([])
  useEffect(() => {
    const loadData = async () => {
      const baseUrl =
        "https://odisse.santepubliquefrance.fr/api/explore/v2.1/catalog/datasets"
      const limit = 100

      try {
        // 1. Fetch des CITIES (Stations)
        // On en profite pour remplacer ton cities.json local par l'API
        const citiesResponse = await fetch(
          `${baseUrl}/sumeau_stations/records?limit=100`,
        )
        const citiesData = await citiesResponse.json()
        // On mappe pour extraire 'fields' ou 'results' selon la structure ODS v2.1
        setCities(citiesData.results || [])

        // 2. Fetch de WATER (Indicateurs) avec pagination
        const waterUrl = `${baseUrl}/sum-eau-indicateurs/records`

        // Premier appel pour avoir le total_count et la première page
        // Ajout de order_by pour que ton calcul de gapFilled (index-1) soit logique
        const firstRes = await fetch(
          `${waterUrl}?limit=${limit}&offset=0&order_by=semaine`,
        )
        const firstData = await firstRes.json()

        let allWater = [...(firstData.results || [])]
        const totalCount = firstData.total_count || 0

        // Boucle séquentielle pour les pages suivantes
        for (let offset = limit; offset < totalCount; offset += limit) {
          const res = await fetch(
            `${waterUrl}?limit=${limit}&offset=${offset}&order_by=semaine`,
          )
          const data = await res.json()
          if (data.results) {
            allWater = allWater.concat(data.results)
          }
        }

        setWater(allWater)
      } catch (err) {
        console.error("Erreur lors du chargement des données SUM'Eau:", err)
      }
    }

    loadData()
  }, [])
  /*
the water data are like that

[

    {
        "date_complet":"2022-08-01",
        "semaine":"2022-S31",
        "national_12":6292.5593389423,
        "national_54":null,
        "amiens":null,
        "angers_la_baumette":null,
        "anglet_pont_de_l_aveugle_no2":null,
        "aquavara":null,
        "auxerre_appoigny":null,
        "bastia_sud":null,
        "besancon_port_douvot":null,
        "bonneuil_en_france":null,
        "bordeaux_louis_fargue_2":null,
        "cannes":null,
        "cap_sicie_amphitria":null,
        "carcassonne_nouvelle":null,
        "carre_de_reunion":null,
        "chalon_sur_saone_port_barois":null,
        "clermont_ferrand":null,
        "cran_gevrier_siloe":null,
        "dijon":null,
        "evry_centre_caece":null,
        "grande_synthe":null,
        "grenoble_aquapole":7665.01082734352,
        "la_baule_escoublac_guerande_livery":null,
        "la_rochelle":null,
        "lagny_sur_marne_st_thibault_des_vignes":null,
        "le_havre":null,
        "lens_loison_sous_lens":null,
        "lescar":5265.09085056278,
        "lille_marquette_lez_lille":null,
        "limoges":null,
        "lmm_le_mans_la_chauviniere":null,
        "lyon_saint_fons":null,
        "maera_ex_cereirede":null,
        "marseille":5065.01718435885,
        "maxeville":10005.2669461277,
        "metz":null,
        "mondeville":null,
        "nantes_1_tougas":5478.62607955148,
        "nice_haliotis":null,
        "nimes":null,
        "orleans_la_chapelle_saint_mesmin":8175.67489179835,
        "paris_marne_aval":null,
        "paris_seine_amont":null,
        "paris_seine_centre":7361.30919238079,
        "poitiers_la_folie":null,
        "reims":null,
        "rennes":5043.18993618149,
        "roubaix_wattrelos":5013.60815519122,
        "rouen":6078.43709929773,
        "saint_brieuc_le_legue":null,
        "saint_etienne_furania":null,
        "sausheim":null,
        "steu_de_brest_zone_portuaire":null,
        "strasbourg_la_wantzenau":null,
        "toulouse_ginestous":null,
        "tours_la_riche_la_grange_david":null,
        "valenciennes":null
    }
]

and cities
[

    {
        "nom":"AQUAVARA",
        "sandre":"0418033S0004",
        "commune":"BOURGES",
        "population":82803,
        "longitude":"2,3816991",
        "latitude":"47,0874261",
        "centroide":{
            "lon":2.3816991,
            "lat":47.0874261
        }
    }
]



*/
  const french = navigator.language === "fr"

  const covid = (
    <abbr
      title="Coronavirus disease 2019"
      data-title="Coronavirus disease 2019"
    >
      COVID-19
    </abbr>
  )

  const sars = (
    <abbr
      title="Severe acute respiratory syndrome coronavirus 2"
      data-title="Severe acute respiratory syndrome coronavirus 2"
    >
      Sars-CoV-2
    </abbr>
  )

  // 2. On transforme en tableau trié
  const sortedWater = [...water].sort((a, b) =>
    a.semaine.localeCompare(b.semaine),
  )

  // 2. Traitement des données (Gap filling)
  const gapFilled = sortedWater.map((week, index, all) => {
    const prevWeek = all[index - 1]
    const nextWeek = all[index + 1]

    // On retourne un nouvel objet pour ne pas muter l'état initial
    return Object.entries(week).reduce((acc, [key, value]) => {
      // On ne traite que les indicateurs (on ignore les métadonnées textuelles)
      const isIndicator = key !== "semaine" && key !== "date_complet"

      // Si la valeur est absente et qu'on a des voisins valides (numériques)
      if (
        isIndicator &&
        (value === null || value === undefined) &&
        typeof prevWeek?.[key] === "number" &&
        typeof nextWeek?.[key] === "number"
      ) {
        acc[key] = (prevWeek[key] + nextWeek[key]) / 2
      } else {
        acc[key] = value
      }

      return acc
    }, {})
  })
  return (
    <>
      <div className="App">
        <header>
          {french ? (
            <h1>
              Surveillance du <span>Sars-CoV-2</span> dans les eaux usées
            </h1>
          ) : (
            <h1>
              <span>Sars-CoV-2</span> monitoring in wastewater{" "}
            </h1>
          )}

          <p>
            {french
              ? "Surveillance de la concentration de "
              : "Monitoring the concentration of "}{" "}
            {sars}
            {french
              ? " dans les eaux usées des stations d'épurations. C'est un indicateur de l'intensité des vagues de circulation virale pour le suivi de pandémie de "
              : " in water treatment plant. This is an indicator of the intensity of viral circulation waves for monitoring the "}
            {covid}
            {french ? "." : " pandemic."}
            {french
              ? " Naviguez en temps réel à travers les "
              : " Browse in real time throught "}
            <a href="#graph" alt="anchor for graph">
              {french ? "Séries temporelles" : "Time series"}
            </a>
            {french ? " et " : " and "}
            <a href="#cartography" alt="anchor for cartography">
              {french ? "Visualisation cartographique" : "Map Visualization"}
            </a>
            .
            {french
              ? " Sélectionez le détails des villes en cliquant sur la carte, le graph, ou la légende."
              : " Select cities details by clicking on the map, the graph, or the legend."}
          </p>
        </header>
        {gapFilled?.length > 0 && cities?.length > 0 && (
          <Dataviz {...{ water: gapFilled, cities }} />
        )}
        <h2>{french ? "A propos" : "About"}</h2>
        <p>
          {french
            ? "Le dispositif français de surveillance des eaux usées "
            : "The french monitoring wastewater system "}
          <abbr
            title={
              french
                ? "nom du dispositif français de surveillance des eaux usées"
                : "name of the french monitoring wastewater system"
            }
          >
            SUM’Eau
          </abbr>
          {french
            ? ` a été initié sous l’impulsion de la direction générale de la santé et de
        la direction de l’eau et de la biodiversité avec l’appui technique et
        scientifique des agences sanitaires. La surveillance des eaux usées
        poursuit deux objectifs, qui sont de détecter précocement la présence du
        génome du SARS-CoV-2 en population générale et de suivre les tendances
        de la circulation virale au sein de la population.`
            : ` was initiated at the instigation of the Directorate General of Health and the Directorate of Water and Biodiversity, with the technical and scientific support of health agencies. Wastewater surveillance pursues two objectives: early detection of the presence of the SARS-CoV-2 genome in the general population and monitoring trends in viral circulation within the population.`}
        </p>
        <p>
          {french
            ? `Les données proposées permettent d’estimer la tendance de circulation du virus SARS-CoV-2 dans les eaux usées au sein de 54 collectivités. Les indicateurs de suivi du SARS-CoV-2 dans les eaux usées sont calculés à partir du ratio entre la concentration virale de SARS-CoV-2 (exprimée en cg/L et quantification réalisée à partir du gène E) et la concentration en azote ammoniacal (exprimée en mg de N/L). Les données obtenues sont ensuite lissées selon la méthode de régression LOESS. Ce lissage peut expliquer une variation des précédentes mesures lors d’une nouvelle livraison. `
            : `The proposed data make possible to estimate the trend of circulation of the SARS-CoV-2 virus in wastewater in 54 municipalities. The indicators for monitoring SARS-CoV-2 in wastewater are calculated from the ratio between the viral concentration of SARS-CoV-2 (expressed in cg/L and quantification based on the E gene) and the concentration of ammoniacal nitrogen (expressed in mg N/L). The data obtained are then smoothed according to the LOESS regression method. This smoothing may explain a variation in the previous measurements when a new delivery is made. `}
          {french
            ? "Plus d'informations sur la régression locale "
            : "More info about Local regression "}{" "}
          <a
            href="https://fr.wikipedia.org/wiki/R%C3%A9gression_locale"
            title="Régression locale sur wikipedia"
          >
            LOESS
          </a>
          .
        </p>
        <p className="info">
          {french
            ? "✔️ Ces données et leurs descriptions sont actualisées en temps réel à partir de "
            : "✔️ Those data and their descriptions are realtime updated from "}
          <a
            title={
              french
                ? "datagouv, la plateforme de diffusion de données publiques de l'État français."
                : "the French government's public data dissemination platform"
            }
            href="https://www.data.gouv.fr/fr/datasets/surveillance-du-sars-cov-2-dans-les-eaux-usees-sumeau/"
          >
            Datagouv
          </a>
          .
          {french
            ? " Les données de Sum'Eau sont livrées à Datagouv avec une à deux semaines de décalage (des fois plus), donc gardez à l'esprit que c'est un indicateur de la circulation virale de la semaine dernière."
            : " Sum'Eau data are delivered to Data.gouv with a one-to-two week delay (sometimes more), so keep in mind that this is an indicator of last week's viral circulation."}
        </p>
        <p className="warn">
          {french
            ? "🛈 Nota bene que la moyenne nationale baisse en général dès Février 2024 à cause de l'élargissement de 12 à 54 stations. La concentration d'urine dans l'eau, la concentration de Sars-CoV-2 dans l'urine, restent bien comparables dans de plus petites villes, c'est une concentration qui est calculé quelque soit la démographie ca reste proportionnel. Par contre vraissemblablement les plus petites villes sont donc moins touchée par le covid soit par la densité démographique plus basse, soit pour des facteurs sociaux."
            : "🛈 Nota bene national average go down since February 2024 because of a changeover from 12 to 54 stations. The concentration of urine in water, the concentration of Sars-CoV-2 in urine, remains comparable in smaller towns, it is a concentration which is calculated whatever the demographics and remains proportional. On the other hand, smaller towns are probably less affected by covid, either due to lower demographic density or due to social factors."}
        </p>
        <p className="warn">
          {french
            ? "🛈 Le dosage de l'azote ammoniacal pour la concentration d'urine dans les eaux usées n'est pas ultime et peut être influencé par d'autres sources telle que l'agriculture tel que l'elevage ou l'usage d'engrais organiques. Ou certaines industries et l'usage de détergents."
            : "🛈 Dosing of ammoniacal nitrogen for urine concentration in wastewater is not ultimate and can be influenced by other sources such as agriculture, livestock or the use of organic fertilizers. Or certain industries and the use of detergents."}
        </p>
        <p className="warn">
          {french
            ? "🛈 N'ayant pas d'informations sur l'horaire et la date en dehors de la plage hebdomadaire des relevés, le dosage pourrait varier selon les stations, on ne peut pas évaluer l'influence des migrations pendulaires et des modes de vie différents (ou non) sur les relevés. "
            : "🛈 Not having informations on the time and date outside the weekly range of readings, the dosage could vary depending on the stations, we cannot assess the influence of commuting migrations and different lifestyles (or not) on the statements."}
        </p>
      </div>
      <WaterFooter>
        <div>
          {french ? "Réalisé par votre " : "Made by your "}
          {french ? "droïde protocolaire " : "protocol droid "}
          {french ? "car " : "because "}
          <i>
            {french
              ? "❝Personne n'aurait pu prédire que [...] Et je ne laisserai personne dire que nous avons manqué à [...]❞"
              : "❝No one could have foreseen this [...] I will not let anyone says that we failed to [...]❞"}
          </i>
          {french
            ? " voulait en fait dire 200k décès facilement évitables"
            : " actually means to say 200k easyly preventables deaths"}
          <br />
          {french ? " Trouvez moi sur " : " Find me on "}
          <a
            title="protocol droid's Bluesky account "
            href="https://bsky.app/profile/droide.bsky.social"
          >
            Bluesky
          </a>
          {french ? " ou " : " or "}
          <a
            alt="protocol droid's Mastodon account"
            href="https://framapiaf.org/@mushroom"
          >
            Mastodon
          </a>
          {" ("}
          {french ? "à l'occasion " : "sometimes "}
          <a
            title="Twitter account of protocol droid"
            href="https://x.com/z8po"
          >
            Twitter/X
          </a>
          )
        </div>
      </WaterFooter>
    </>
  )
}

export default App
